
var bundle = "";
var bundleUrls = [];
// list to mark already loaded scripts
var loaded = [];

// return filename from url without query string
function filenameUrl(url) {
    var filename = url.substring(url.lastIndexOf('/')+1);
    var query = filename.indexOf('?');
    if( query >= 0 ) {
        filename = filename.substring(0, query);
    }
    return filename;
}


function importUrl( url , immediate = false ) {
    // check if script is already loaded
    const filename = filenameUrl(url);
    if( loaded.indexOf( filename ) >= 0 ) {
        console.log("script already loaded: ", filename);
        return;
    }
    var ajax = new XMLHttpRequest();
    ajax.open( 'GET', url, false ); 
    ajax.onreadystatechange = function () {
        var script = ajax.response || ajax.responseText;
        if (ajax.readyState === 4) {
            switch( ajax.status) {
                case 200:
                    if( loaded.indexOf( filename ) >= 0 ) return;

                    console.log("script loaded: ", url);
                    if (immediate) {
                        console.log("installing script: ", url);
                        eval.apply( window, [script] );
                    } else {
                        bundle=bundle+script;
                        bundleUrls.push(filename);                        
                    }
                    loaded.push( filename );
                    
                    return;
                default:
                    console.log("ERROR: script not loaded: ", url);
            }
        }
    };
    ajax.send(null);
}
//importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki-jquery-3.7.0.min.js?v=73579766258908542481753973027");
importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki-giosg.js?v=46423840946511185501753973025"); 
//importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki.js?v=107701058669575164301753973037"); 
//importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki_chat.js?v=64752555295761777291753973039"); 
//importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki_api.js?v=62768702438557609801753973038"); 
//importUrl("//www.nettiapteekki.fi/cdn/shop/t/215/assets/nettiapteekki_chat_authentication.js?v=93493457607813497921753973040"); 

eval.apply( window, [bundle] );
bundle = "";
bundleUrls = [];
